export class TipoConteudoModel {
  id: number;
  descricao: String;
  propriedades?: any[];
  aspectos?: any[];
  tipoOriginal?: any;
  projeto?: any;
}



// WEBPACK FOOTER //
// /app/src/app/model/caixa/tipoconteudo.model.ts